// Constantes del store. En el state están como this.$store.state.colecciones, this.$store.state.arreglos y this.$store.state.ruta.
import { COLLECTION_KEYS as LFCK } from "@/utils/localforage/collectionkeys";
import { COLLECTION_KEYS as FSCK } from "@/utils/firebase/collectionkeys";

// COLECCIONES PARA USO OFFLINE Y ONLINE
export const colecciones = {
  localforage: LFCK,
  firebase: FSCK,
};

export const arreglos = {
  empresas: {
    planesAccion: {
      estados: ["Pendiente", "Abierto", "Cerrado"],
      verificacion: {
        estados: ["Pendiente", "Verificado"],
      },
      resultados: [
        "Pendiente",
        "Aceptable",
        "Con Control Específico",
        "No Aceptable",
      ],
      actividades: {
        tipos: ["Correctiva", "Preventiva", "Mejora", "Observación"],
        origenes: [
          "Documental",
          "Siniestralidad",
          "Operacional",
          "Mantenimiento",
          "Capacitación",
          "Auditoría",
        ],
        modulos: [
          {
            nombre: "Seguridad Vial - Conductores - Exámenes",
            coleccion:
              colecciones.firebase.seguridadVial.conductores.examenes.registros,
          },
          {
            nombre: "Seguridad Vial - Conductores - Licencias",
            coleccion:
              colecciones.firebase.seguridadVial.conductores.licencias
                .registros,
          },
          {
            nombre: "Seguridad Vial - Conductores - Revisión de Comparendos",
            coleccion:
              colecciones.firebase.seguridadVial.conductores.revisiones
                .registros,
          },
          {
            nombre: "Seguridad Vial - Vehículos - Documentos",
            coleccion:
              colecciones.firebase.seguridadVial.vehiculos.documentos.registros,
          },
          {
            nombre: "Seguridad Vial - Vehículos - Revisión de Comparendos",
            coleccion:
              colecciones.firebase.seguridadVial.vehiculos.revisiones.registros,
          },
          {
            nombre: "Seguridad Vial - Inspecciones",
            coleccion:
              colecciones.firebase.seguridadVial.inspecciones.registros,
          },
        ],
        estados: ["Pendiente", "Abierta", "Cerrada"],
        verificacion: {
          estados: ["Pendiente", "Verificada"],
          cumple: {
            estados: ["Pendiente", "Si", "No"],
          },
        },
      },
    },
  },
  seguridadVial: {
    novedades: {
      aplicaPara: ["Conductor", "Vehículo", "Conductor y Vehículo"],
      motivos: [
        "Capacitación o Entrenamiento",
        "Condiciones Climáticas Extremas",
        "Descanso",
        "Falla Mecánica",
        "Incapacidad",
        "Mantenimiento",
        "Pasajero",
        "Permiso",
        "Permiso No Remunerado",
        "Permiso Remunerado",
        "Pico y Placa",
        "Reasignación Temporal del Vehículo",
        "Trabajo en Oficina",
        "Vacaciones",
        "Viaje Laboral",
      ],
    },
    estadoComparendos: ["Pago", "Por Pagar", "Apelación"],
    vehiculos: {
      tiposDocumento: [
        "SOAT",
        "Revisión Técnico Mécanica",
        "Póliza Todo Riesgo",
        "Póliza Contra Actual",
        "Carta de Propiedad",
        "Rutograma",
        "Aval de Vehículo",
      ],
    },
    inspecciones: {
      tiposInspeccion: ["Pre-Operacional", "Trimestral", "Semestral"],
      estadosInspeccion: ["Apto", "Con Control Específico", "No Apto"],
      exentosInspeccion: [
        // ECOPETROL
        {
          idEmpresa: "6DECDG5bFiLX6hJNRak8",
          usuarios: [
            "JF37dubC4HQjt2snZvvV07dXY2f2",
            "PoyYYtPgvbeTFTSghd3fCiKG8n33",
            "PkuvCjMhG9dtPzw1LSbq3zteI4u1",
            "ah5nLwCNiVQuggdKszA4PClcfjP2",
            "N9nWPRrjlKQ4SifRRkzGBW8KOf23",
            "hb6kFkVxVhTj55ayiXtwWK55IVG2",
            "f7vxegJHlCWTPLBpFrOqbruPDtb2",
            "jN0RUU1HvubvMBLUd3PiVPkJFxi2",
            "74MoSudBIhQOxh6rlGfqCK1AizV2",
          ],
        },
        // BARRANQUILLA TECH
        {
          idEmpresa: "T06YBpQNn6w1dU0KSb9E",
          usuarios: [
            "E4cvKrNqSrMK3zZj7cjPFWamrre2",
            "oRh8SVLBHqMTeBaWvO4QESbPVdF2",
            "5JGA7cM58BMI7NB1SHlIREIP5s92",

            "0HAGUtTrtjaO4xhljBqUlVeqiQq1",

            "1tthl9VsOhY7YR1e2WQtEnc1NTF3",
            "4bTCnCPyi2h6w0dMIAOBlZs6xiz1",

            "9t3s1HtS4cQtHT2RZyfhc0YE4803",
            "DyUH0vZUzXTtS52YwMqr92JTm852",

            "Ld95o48Mx2R1iDNbMdKcfv9hqD33",
            "Px0GVf1VNdeYUhWxUPI5NHZcoeK2",
            "SggfAgQXPOgnt5CLGs4eLeBrBWu2",
            "SzikSAhVgKXmK9iTMjXztEv471s1",
            "T5QxLHwUzSgYkS6QwXMTBZ3o8Ae2",
            "TL5VfrOSWLXiakZ6qNYn3yN1FLF3",
            "YWqpLMShL2SKt053qMHeAAvdZBl2",
            "YeLLTLIDTlXZNUVbqdnxi1pphS53",
            "Z6VaRCwkRETGbBClx5XT4ixVdaw2",
            "ap1czXtObYbWH8NlYUwZRIiY2IH2",
            "brEURyytN1dsqvcBFLhHkiYiCPC3",
            "dBXkjU4ZWzSkoKCOWp9CHeUtwZg2",
            "egfmYk5KRNeWaROLKcr5olCW1KK2",
            "hRJvHO4hUoX2OhZP2HVwGxUNXhn1",
            "igZkA8JZTgRvl76CxYHFTR1b4ON2",
            "lEM5tr8aNgfu1bMzGfTdfkpxvA83",
            "m4VuULxBLLYPznsWQhNpR8js68H3",
            "nVCmAzvkPLMHIoEhclGxUL2d5sy2",
            "o61aYQ4ThqXpBY6lu0QPKKeu5pG3",

            "prlWIksXuIgY3d7dyZ3MLBfsB003",
            "qEvE8r7MU0UQV4ogH2WM2DAlIwD2",
            "uKtytTbvOKWEq9J675p4FaCuojT2",
            "veJSHR6vYZeUF0yuBnE7QRlUGOk2",
            "xLIv6VM8tWRBGGysVbEWEdsSPxg1",
            "yIKv69tfD7VqwR3Eg2DY5NFins33",
            "yaV2bLzz7jPL29h5iSbV9gdy0543",

          ],
        },
        // NOROCCIDENTE - SECURE
        {
          idEmpresa: "Q3tgIDf2JXq8nByuVqXa",
          usuarios: [
            "DHadvib29zLgFU6vKhg5AWQPYNr1",
            "iF9ObMhbYRTMTc9Apuh3FdUpTNy2",
            "OWa3KIz1Ipd8esVLQHsf7Et18E82",
            "6ww5XWF6gefyrb2St0TnA4J2HkT2",
          ],
        },
        // SECURE SABANA & LLANOS
        {
          idEmpresa: "dasA6tfoX4dvi09kOR1L",
          usuarios: [
            "JF37dubC4HQjt2snZvvV07dXY2f2",
            "FoH16k2WuufGCNWIclTeF9RpTQx2",
          ],
        },
        // TECHNOLOGY SABANA & SANTANDERES
        {
          idEmpresa: "G6XEPvbvvf8oPhFHcTFX",
          usuarios: ["HLi6xYTvebQf2Fr4iJkFlHQQB6u2"],
        },
        // G4S - SABANA & LLANOS - SECURE - PUESTOS GENERALES
        {
          idEmpresa: "Hq9C50tFGVXoL9lVUFdS",
          usuarios: [
            "m65O2KFVVEgkyQ3Deun5BcvLTLZ2",
            "ItBIJKcpPfYBaFqhbpT9qLoqPZ43",
            "3XjeZDRujhcEWWom0tGZ486zywv1",
          ],
        },
        // G4S - SANTANDERES - OPERACION SECURE
        {
          idEmpresa: "LCxBZ0ryHqBHhA89d12A",
          usuarios: [
            "oKnkddZZyoeDqi7ZHB0ROZ84FpM2",
            "P9eRUedFhjRVoehPygVkWrQkWiF2",
            "0oJMtsEvahQjGX53wngxngL3TG12",
            "n3Yon5BGNpZFTfgD9lvQ2ZhZs652",
            "hhX3DIZYOBXdsz3k43hCOKDxrsl2",
          ],
        },
        // G4S - TECH - BOGOTA
        {
          idEmpresa: "xnMBLFaJLcB6TWNxYxqR",
          usuarios: [
            "tHh54ikGFqZgUFndqh0CGLaTe6E3",
          ],
        },
        // G4S - SABANA & LLANOS - SECURE - SOC SABANA
        {
          idEmpresa: "NqvN1yLLuHHfAXuGtbz3",
          usuarios: [
            "N2pGHimYbNMqbY6SqGLLc96bduH2",
          ],
        },
      ],
    },
    planesDesplazamientos: {
      estadosPlan: ["Pendiente", "En Curso", "En Descanso", "Finalizado"],
      mediosComunicacion: [
        `Celular`,
        `Radio de Comunicaciones`,
        `Directorio de Puntos de Apoyo`,
        `Tarjetas de Emergencia`,
        `Equipo para Atención de Derrames`,
        `Botón de Pánico`,
      ],
      condicionesRiesgo: [
        `Vía de alto tráfico`,
        `Paso frecuente de equipo pesado con cargas anchas y largas`,
        `Paso sobre bateas y / o quebradas`,
        `Zonas escolares`,
        `Puentes con paso restringido`,
        `Líneas eléctricas cruzando la vía a baja altura`,
        `Vía en construcción`,
        `Zona de derrumbes frecuentes`,
        `Poblaciones, caseríos, área de peatones`,
        `Vías angostas`,
        `Hospitales`,
        `Vías destapadas y con material suelto`,
        `Paraderos para recoger o dejar pasajeros`,
        `Intersecciones peligrosas`,
      ],
    },
    aptitudes: {
      estados: ["Apto", "Con Control Específico", "No Apto"],
    },
    formatos: {
      categorias: [
        "Borradores",
        "Inspección de Vehículos",
        "Planificación de Desplazamientos",
      ],
    },
    cuestionarios: {
      categorias: ["Infografías"],
    },
    siniestros: {
      tipos: ["Accidente", "Incidente"],
      afectaciones: {
        bienes: {
          materiales: ["Con Daños a Bienes", "Sin Daños a Bienes"],
        },
        personas: {
          lesiones: [
            "Con Lesiones Graves",
            "Con Lesiones Leves",
            "Muerte",
            "Incapacidad De Más De 30 Días",
            "Incapacidad Hasta 30 Días",
            "Primeros Auxilios",
            "Sin Lesiones",
          ],
        },
        medioAmbiente: [
          "Contaminación Ambiental Severa",
          "Contaminación Ambiental Media",
          "Contaminación Ambiental Leve",
          "Derrames",
          "Sin Afectación al Medio Ambiente",
          "No Aplica",
        ],
        costos: [
          "Más De $100.000.000",
          "Entre $10.000.000 Y $100.000.000",
          "Entre $1.000.000 Y $10.000.000",
          "Menos De $1.000.000",
          "No Aplica",
        ],
        reputaciones: [
          "Conocimiento En Medios De Comunicación A Nivel Internacional",
          "Conocimiento En Medios De Comunicación A Nivel Nacional",
          "Conocimiento En Medios De Comunicación A Nivel Local",
          "Conocimiento En El Sector O En El Entorno De La Empresa",
        ],
      },
      investigacionesSanciones: [
        "Investigaciones Y Sanciones Críticas",
        "Investigaciones Y Sanciones Medias",
        "Investigaciones Y Sanciones Bajas",
        "Quejas y Reclamos / Errores Humanos",
        "Sin Investigaciones O Sanciones",
        "No Aplica",
      ],
      danosConsecuencias: [
        "Volcamiento",
        "Semivolcamiento, Tijera",
        "Salida de la Vía",
        "Choques Simples",
        "Sin Daños O Consecuencias",
        "No Aplica",
      ],
      causasProbables: [
        "Distracción",
        "Mal Estado de la Vía",
        "Exceso de Velocidad",
        "Falla Mecánica",
        "Por Definir",
        "No Aplica",
      ],
      condiciones: {
        vias: ["Mojada", "Seca", "En Reparación", "Destapada"],
        climaticas: [
          "Niebla",
          "Soleado",
          "Lluvia",
          "Granizo",
          "Buen Tiempo",
          "Tormenta",
          "Tormenta Eléctrica",
        ],
      },
      estadosVehiculo: ["Aprobado", "No Aprobado"],
      usosCinturonEpp: ["Si", "No", "No Aplica"],
      accionesMejora: [
        "Revisión Técnica",
        "Investigación en Curso",
        "Capacitación",
        "Por Definir",
      ],
    },
  },
  panelAdministrativo: {
    seguridadVial: {
      formatos: {
        plantillas: {
          categorias: [
            "Inspección de Vehículos",
            "Planificación de Desplazamientos",
          ],
        },
      },
    },
  },
};

export const ruta = "https://riskmanndev.web.app/";
